import { render } from "./SectionPlatformTags.vue?vue&type=template&id=052f04c6&scoped=true"
import script from "./SectionPlatformTags.vue?vue&type=script&lang=js"
export * from "./SectionPlatformTags.vue?vue&type=script&lang=js"

import "./SectionPlatformTags.vue?vue&type=style&index=0&id=052f04c6&scoped=true&lang=css"
import "./SectionPlatformTags.vue?vue&type=style&index=1&id=052f04c6&lang=css"

import exportComponent from "/codebuild/output/src1932422480/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-052f04c6"]])

export default __exports__